// Published papers, newest first. `pdf` is the local download path in
// public/assests/; `journalUrl` is optional and links to the publisher.

export const publications = [
  {
    title: "Blockchain-Based Patch Management System",
    role: "Co-author",
    year: "2026",
    journal:
      "International Journal of Research Publication and Reviews (IJRPR)",
    issn: "ISSN 2582-7421",
    journalUrl: "https://ijrpr.com",
    description:
      "Decentralised patch management architecture addressing tampering, spoofing, and single-point-of-failure risks in centralised update systems, using blockchain for immutable records, IPFS storage, smart contract role-based access control, and SHA-256 verification before installation.",
    pdf: "/assests/BPMS-IEEE-Paper.pdf",
  },
];
